import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { BookmarkCheck, Heart, Sparkles, X, ArrowLeft, ExternalLink } from "lucide-react";
import { Reader, savedItems } from "@/pages/News";

const GRADIENTS = [
  "from-amber-400/30 to-rose-400/20", "from-emerald-400/30 to-teal-400/20",
  "from-sky-400/30 to-indigo-400/20", "from-fuchsia-400/30 to-purple-400/20",
];

export default function SavedNews() {
  const [list, setList] = useState(() => savedItems());
  const [active, setActive] = useState(null);

  const remove = (id) => {
    const next = savedItems().filter((x) => x.id !== id);
    localStorage.setItem("anxya_saved_news", JSON.stringify(next));
    setList(next);
  };

  return (
    <div className="max-w-6xl mx-auto px-5 pt-24 pb-16" data-testid="saved-page">
      <Link to="/news" className="inline-flex items-center gap-1.5 text-sm text-sec hover:text-brand"><ArrowLeft size={15} /> Back to Good News</Link>
      <div className="flex items-center gap-2 mt-3"><BookmarkCheck className="text-brand" /><h1 className="font-serif text-4xl tracking-tight">Rays of Hope</h1></div>
      <p className="text-sec text-sm mt-2 max-w-2xl">Every story you've saved, kept close for whenever you need a little light. 🌟</p>

      {list.length === 0 ? (
        <div className="mt-12 text-center" data-testid="saved-empty">
          <Heart className="text-brand/60 mx-auto" size={40} />
          <p className="text-sec mt-3">No saved stories yet.</p>
          <Link to="/news" className="btn-primary rounded-full h-10 px-5 inline-flex items-center gap-2 mt-4 text-sm">Discover Good News</Link>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-6" data-testid="saved-list">
          {list.map((n, i) => (
            <div key={n.id} className="rud-card rounded-2xl overflow-hidden group flex flex-col relative" data-testid="saved-card">
              <button onClick={() => remove(n.id)} data-testid="saved-remove" className="absolute top-2 right-2 z-10 bg-black/60 rounded-full p-1.5 hover:bg-black/80"><X size={14} /></button>
              <button onClick={() => setActive(n)} className="text-left flex flex-col flex-1">
                {n.image ? (
                  <div className="h-40 w-full overflow-hidden"><img src={n.image} alt="" loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" onError={(e) => { e.currentTarget.parentElement.style.display = "none"; }} /></div>
                ) : (
                  <div className={`h-40 w-full bg-gradient-to-br ${GRADIENTS[i % GRADIENTS.length]} grid place-items-center`}><Heart className="text-brand/70" size={30} /></div>
                )}
                <div className="p-5 flex flex-col flex-1">
                  <span className="text-[10px] uppercase tracking-widest text-brand flex items-center gap-1"><Sparkles size={11} /> {n.category}</span>
                  <h3 className="font-serif text-lg mt-2 leading-snug">{n.title}</h3>
                  {n.summary && <p className="text-sm text-sec mt-2 line-clamp-3 flex-1">{n.summary}</p>}
                  <div className="flex items-center justify-between mt-3 text-xs text-sec">
                    <span>{n.source}</span>
                    <span className="inline-flex items-center gap-1 text-brand">Read here <ExternalLink size={11} /></span>
                  </div>
                </div>
              </button>
            </div>
          ))}
        </div>
      )}

      <AnimatePresence>
        {active && <Reader item={active} onClose={() => { setActive(null); setList(savedItems()); }} />}
      </AnimatePresence>
    </div>
  );
}
